import React, { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import CustomLink from '../../common/custom-link';

type ButtonLinkWrapperPropsType = ButtonHTMLAttributes<HTMLButtonElement> & {
    children?: ReactNode;
    href?: string;
};

const ButtonLinkWrapper: FC<ButtonLinkWrapperPropsType> = ({ children, href, ...props }) => {
    return href ? (
        // @ts-ignore
        <CustomLink
            {...props}
            to={href}
            onClick={(e: React.MouseEvent<HTMLElement>) => {
                if (props.disabled) {
                    e.preventDefault();
                } else if (props.onClick) {
                    props?.onClick(e as React.MouseEvent<HTMLButtonElement, MouseEvent>);
                }
            }}
        >
            {children}
        </CustomLink>
    ) : (
        <button {...props}>{children}</button>
    );
};

export default ButtonLinkWrapper;
